import Analytics from '../../../../../../../../../analytics';
import OmnitureUtils from '../../../../../../../../common/utils/Omniture/OmnitureUtils';

export const faOnAddonCardClick = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'Click_card_addon',
  });
  OmnitureUtils.trackClickEvent({
    prop54: 'Click_card_addon',
    prop1: 'VPP',
  });
};

export const faOnTncClick = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'VPP_TnC|VPP:overlay',
  });
  OmnitureUtils.trackClickEvent({
    prop54: 'VPP_TnC',
    prop1: 'VPP:overlay',
  });
};
